"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var chain_jslib_1 = require("@crypto-com/chain-jslib");
var errors_1 = require("@ledgerhq/errors");
var hw_app_cosmos_1 = __importDefault(require("@ledgerhq/hw-app-cosmos"));
var errors_2 = require("./errors");
var operation_1 = require("../../operation");
var deviceAccess_1 = require("../../hw/deviceAccess");
var js_buildTransaction_1 = require("./js-buildTransaction");
var logic_1 = require("./logic");
var buildOptimisticOperation = function (account, transaction, fee) {
    var type = "OUT";
    var value = new bignumber_js_1.BigNumber(transaction.amount).plus(fee);
    var operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type: type,
        value: value,
        fee: fee,
        blockHash: null,
        blockHeight: null,
        senders: [account.freshAddress],
        recipients: [transaction.recipient].filter(Boolean),
        accountId: account.id,
        date: new Date(),
        extra: {
            additionalField: transaction.amount
        }
    };
    return operation;
};
function convertASN1toBase64(signature) {
    // 0 0x30: a header byte indicating a compound structure
    // 1 A 1-byte length descriptor for all what follows (ignore)
    // 2 0x02: a header byte indicating an integer
    // 3 A 1-byte length descriptor for the R value
    // 4 The R coordinate, as a big-endian integer
    //   0x02: a header byte indicating an integer
    //   A 1-byte length descriptor for the S value
    //   The S coordinate, as a big-endian integer
    //  = 7 bytes of overhead
    if (signature[0] !== 0x30) {
        throw new errors_2.CryptoOrgWrongSignatureHeader();
    }
    // decode DER string format
    var rOffset = 4;
    var rLen = signature[3];
    var sLen = signature[4 + rLen + 1]; // skip over following 0x02 type prefix for s
    var sOffset = signature.length - sLen;
    var sigR = signature.slice(rOffset, rOffset + rLen); // skip e.g. 3045022100 and pad
    var sigS = signature.slice(sOffset);
    var newSigR = padZero(sigR, 32);
    var newSigS = padZero(sigS, 32);
    var signatureFormatted = Buffer.concat([newSigR, newSigS]);
    if (signatureFormatted.length !== 64) {
        throw new errors_2.CryptoOrgSignatureSize();
    }
    return signatureFormatted;
}
function padZero(original_array, wanted_length) {
    var new_array = new Uint8Array(wanted_length);
    for (var i = wanted_length - 1; i >= 0; i--) {
        var j = wanted_length - 1 - i;
        var new_i = original_array.length - 1 - j;
        if (new_i >= 0 && new_i < original_array.length) {
            new_array[i] = original_array[new_i];
        }
        else {
            new_array[i] = 0;
        }
    }
    return new_array;
}
/**
 * Sign Transaction with Ledger hardware
 */
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return rxjs_1.Observable.create(function (o) {
            function main() {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var hwApp, cointype, publicKey, unsigned, signature, base64Sig, signed, operation;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                o.next({
                                    type: "device-signature-requested"
                                });
                                if (!transaction.fees) {
                                    throw new errors_1.FeeNotLoaded();
                                }
                                hwApp = new hw_app_cosmos_1["default"](transport);
                                cointype = (0, logic_1.isTestNet)(account.currency.id) ? "tcro" : "cro";
                                return [4 /*yield*/, hwApp.getAddress(account.freshAddressPath, cointype, false)];
                            case 1:
                                publicKey = (_b.sent()).publicKey;
                                return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(account, transaction, publicKey)];
                            case 2:
                                unsigned = _b.sent();
                                return [4 /*yield*/, hwApp.sign(account.freshAddressPath, unsigned.toSignDocument(0).toUint8Array())];
                            case 3:
                                signature = (_b.sent()).signature;
                                // Ledger has encoded the sig in ASN1 DER format, but we need a 64-byte buffer of <r,s>
                                // DER-encoded signature from Ledger
                                if (signature != null) {
                                    base64Sig = convertASN1toBase64(signature);
                                    signed = unsigned
                                        .setSignature(0, chain_jslib_1.utils.Bytes.fromUint8Array(new Uint8Array(base64Sig)))
                                        .toSigned()
                                        .getHexEncoded();
                                    o.next({
                                        type: "device-signature-granted"
                                    });
                                    operation = buildOptimisticOperation(account, transaction, (_a = transaction.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0));
                                    o.next({
                                        type: "signed",
                                        signedOperation: {
                                            operation: operation,
                                            signature: signed,
                                            expirationDate: null
                                        }
                                    });
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map